module.exports = __webpack_public_path__ + "assets/e342ebfe4e667c5c53f941e31be541ba.png";